import type { MVNType } from "src/numbers/objects/MVNType";
import ContactClass from "src/shared/contacts/objects/Contact";
import Term from "src/shared/term/objects/Term";
import type TermNameType from "src/shared/term/objects/TermNameType";

export class Merchant extends ContactClass {
  public merchantUUID: string;
  public merchantName: string;
  public merchantShortName: string;
  public merchantGroupUUID: string;
  public logoUrl: string;
  public supportEmail: string;
  public mobileVirtualNumber: string;
  public mobileVirtualNumberStatus: "NOT_VERIFIED" | "VERIFIED" | "ERROR";
  public mobileVirtualNumberStatusTimestamp: string;
  public providerId?: number;
  public mvnType: MVNType;
  public subscriberCount: number;
  public merchantStatus: boolean;
  public isSuspended: boolean;
  public cooldownInterval?: number;
  public privacyPolicy: Term;
  public tnc: Term;
  public ttc: Term;
  public isChat: boolean;
  public isTwoStepOptIn: boolean;
  public isDispatchExtended: boolean;
  public notes?: string;
  public carrierGoLive?: string;
  public monthlyVolumeExpected?: number;
  public monthlyVolumeLimit?: number;
  public isMms: boolean;

  constructor(obj: any = {}) {
    super(obj);

    if (obj) {
      this.merchantUUID = obj.merchantUUID;
      this.merchantName = obj.merchantName;
      this.merchantShortName = obj.merchantShortName;
      this.merchantGroupUUID = obj.merchantGroupUUID as string;
      this.logoUrl = obj.logoUrl;
      this.supportEmail = obj.supportEmail;
      this.mobileVirtualNumber = obj.mobileVirtualNumber || "";
      this.mobileVirtualNumberStatus = obj.mobileVirtualNumberStatus;
      this.mobileVirtualNumberStatusTimestamp =
        obj.mobileVirtualNumberStatusTimestamp;
      this.providerId = obj.providerId;
      this.mvnType = obj.mvnType;
      this.subscriberCount = obj.subscriberCount;
      this.merchantStatus = obj.merchantStatus === "1";
      this.isSuspended = obj.isSuspended;
      this.cooldownInterval = obj.cooldownInterval;

      this.privacyPolicy = createTerm("prv", obj);
      this.tnc = createTerm("tnc", obj);
      this.ttc = createTerm("ttc", obj);

      this.isChat = obj.isChat;
      this.isTwoStepOptIn = obj.isTwoStepOptIn;
      this.isDispatchExtended = obj.isDispatchExtended;

      this.notes = obj.notes;

      this.carrierGoLive = obj.carrierGoLive;

      this.monthlyVolumeExpected = obj.monthlyVolumeExpected;
      this.monthlyVolumeLimit = obj.monthlyVolumeLimit;
      this.isMms = obj.isMms;
    }
  }

  public toJSON(): object {
    const { privacyPolicy, tnc, ttc, ...rest } = this;
    return {
      ...rest,
      ...termToJson("prv", privacyPolicy),
      ...termToJson("tnc", tnc),
      ...termToJson("ttc", ttc),
    };
  }
}

/**
 * @deprecated
 */
export default Merchant;

export interface IMerchantAbstract {
  merchantUUID: string;
  merchantName: string;
}

export interface IMerchantAbstractNew {
  merchantUuid: string;
  merchantName: string;
}

function createTerm(termName: TermNameType, obj: any): Term {
  return new Term({
    termClass: obj[termName + "TermClass"],
    termText: obj[termName + "TermText"],
    termUrl: obj[termName + "TermUrl"],
  });
}

function termToJson(termName: TermNameType, term: Term): object {
  const termJson: object = {};
  Object.entries(term.toJSON()).forEach(([key, value]) => {
    termJson[termName + key.charAt(0).toUpperCase() + key.slice(1)] = value;
  });
  return termJson;
}
